import { Row } from "@tanstack/react-table";

export const resolveDraggableRowId = <T>(row: Row<T>, draggableId?: string): string => {
  if (!draggableId) {
    return String(row.id);
  }

  const rowData = row.original as unknown;

  if (!rowData || typeof rowData !== "object") {
    return String(row.id);
  }

  const candidate = (rowData as Record<string, unknown>)[draggableId];

  if (typeof candidate === "string" && candidate.length) {
    return candidate;
  }

  if (typeof candidate === "number" && Number.isFinite(candidate)) {
    return String(candidate);
  }

  return String(row.id);
};
